import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetBankDetailsForEmployee() {
  const { id } = useParams();

  return useQuery(['employee-bankdetails'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_BANK_DETAILS, {
        employee_id: id,
      })
    );
    return res.data;
  });
}
